import { render, staticRenderFns } from "./ComplaintsFilterButton.vue?vue&type=template&id=3799235a&scoped=true&"
import script from "./ComplaintsFilterButton.vue?vue&type=script&lang=js&"
export * from "./ComplaintsFilterButton.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsFilterButton.vue?vue&type=style&index=0&id=3799235a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3799235a",
  null
  
)

export default component.exports